export default "__VITE_PUBLIC_ASSET__ea244c9e__"